import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.25 2.5H12.5a1.25 1.25 0 0 0-1.25 1.25v12.5a1.25 1.25 0 0 0 1.25 1.25h3.75a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25m0 13.75H12.5v-2.5h1.875a.624.624 0 1 0 0-1.25H12.5v-1.875h1.875a.624.624 0 1 0 0-1.25H12.5V7.5h1.875a.625.625 0 1 0 0-1.25H12.5v-2.5h3.75zM6.067 2.058a.625.625 0 0 0-.884 0l-2.5 2.5A.63.63 0 0 0 2.5 5v11.25a1.25 1.25 0 0 0 1.25 1.25H7.5a1.25 1.25 0 0 0 1.25-1.25V5a.63.63 0 0 0-.183-.442zM3.75 13.75v-7.5H5v7.5zm2.5-7.5H7.5v7.5H6.25zm-.625-2.866L7.241 5H4.01zM3.75 16.25V15H7.5v1.25z"
    />
  </svg>
);
const SvgIconPencilRuler = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPencilRuler);
export default Memo;
